import { FilteredSearchBar, type FilteredSearchBarProps } from './FilteredSearchBar'
import { useListFilters, type ListFilterOptions } from './useListFilters'

export type ListSearchBarProps = ListFilterOptions & Pick<FilteredSearchBarProps, 'ariaLabel'>

/** A URL-backed list header using the same interaction as controlled Network Manager lists. */
export function ListSearchBar({ ariaLabel, ...options }: ListSearchBarProps) {
    const { barProps } = useListFilters(options)
    return <FilteredSearchBar {...barProps} ariaLabel={ariaLabel} />
}
